/*
 * @Author: hjp hjp@hjp.com
 * @Date: 2022-09-09 09:50:34
 * @LastEditors: luodongming
 * @LastEditTime: 2025-01-02 09:52:30
 * @FilePath: \yelink-ecm-developer-web\src\api\applet-store\index.js
 * @Description: 小程序管理页面接口
 */
import request from '@/utils/request-app'

// 获取一个开发者的开发者组织列表
export function getDeveloperOrganization(params) {
  return request({
    url: '/developer/developerOrganization',
    method: 'get',
    params
  })
}
// 创建一个开发者组织
export function createDeveloperOrganization(data) {
  return request({
    url: '/developerOrganization',
    method: 'post',
    data
  })
}
// 分页获取小程序列表，支持根据小程序名称模糊匹配
export function getAppList(query) {
  return request({
    url: '/developer/appstore',
    method: 'get',
    params: query
  })
}
// 创建小程序，只支持创建本地小程序
export function addLocalApp(data) {
  return request({
    url: '/developer/appstore',
    method: 'post',
    data
  })
}
// 编辑小程序
export function editLocalApp(data) {
  return request({
    url: '/developer/appstore',
    method: 'put',
    data
  })
}
// 根据appId获取小程序的详细信息
export function getAppDetail(appId) {
  return request({
    url: `/developer/appstore/detail/${appId}`,
    method: 'get'
  })
}
// 根据ecmAppId查询已上架skill小程序最新版本的packagePath（返回 data 为 packagePath 字符串）
export function getSkillPackagePath(ecmAppId) {
  return request({
    url: '/developer/appstore/skill/packagePath',
    method: 'get',
    params: { ecmAppId }
  })
}
// 根据appId获取小程序在ecm平台的信息
export function getEcmDetail(appId) {
  return request({
    url: `/developer/appstore/detail/ecm/${appId}`,
    method: 'get'
  })
}
// 根据appId获取小程序的历史版本
export function getHistoryVersion(query) {
  return request({
    url: `/developer/appstore/release`,
    method: 'get',
    params: query
  })
}
// 删除版本信息，只有处于未上架状态的版本才能被删除
export function deAppstoreRelease(query) {
  return request({
    url: `/developer/appstore/release`,
    method: 'delete',
    params: query
  })
}
// 设置小程序发布状态
export function setReleaseAppStatus(data) {
  return request({
    url: `/developer/appstore/release/status`,
    method: 'put',
    params: data
  })
}
// 读取小程序包中的小程序版本信息
export function getReleaseInfo(data) {
  return request({
    url: `/developer/appstore/releaseInfo`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 校验 skill.md 或压缩包
export function validateSkillFile(data) {
  return request({
    url: `/developer/appstore/skill/validate`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// v2-上传文件到obs
export function uploadObs(data) {
  return request({
    url: `/file/upload/obs`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
//   更新小程序版本
export function updateLocalApp(data) {
  return request({
    url: `/developer/appstore/version`,
    method: 'put',
    data
  })
}
// 删除小程序
export function delLocalApp(appId) {
  return request({
    url: `/developer/appstore/${appId}`,
    method: 'delete'
  })
}
// 获取小程序类型列表
export function getAppCategory(query) {
  return request({
    url: `/developer/appCategory`,
    method: 'get',
    params: query
  })
}
// 新建类型
export function addAppCategory(data) {
  return request({
    url: `/developer/appCategory`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
//   修改类型
export function editAppCategory(data) {
  return request({
    url: `/developer/appCategory`,
    method: 'put',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
//   获取所有类型
export function getAppCategoryAll() {
  return request({
    url: `/developer/appCategory/all`,
    method: 'get'
  })
}
//   变更类型顺序
export function eidtOrder(data) {
  return request({
    url: `/developer/appCategory/order`,
    method: 'put',
    data
  })
}
//   删除类型
export function delAppCategory(id) {
  return request({
    url: `/developer/appCategory/${id}`,
    method: 'delete'
  })
}
// 分页获取集合列表，支持根据集合名称模糊匹配
export function getAppCollection(query) {
  return request({
    url: `/developer/appCollection`,
    method: 'get',
    params: query
  })
}
//   新建一个集合
export function addAppCollection(data) {
  return request({
    url: `/developer/appCollection`,
    method: 'post',
    data
  })
}
//   编辑集合信息
export function editAppCollection(data) {
  return request({
    url: `/developer/appCollection`,
    method: 'put',
    data
  })
}
//   分页获取集合绑定的小程序列表
export function appCollectionBindAppList(query) {
  return request({
    url: `/developer/appCollection/app`,
    method: 'get',
    params: query
  })
}
//   集合绑定小程序
export function addAppCollectionBindApp(data) {
  return request({
    url: `/developer/appCollection/app`,
    method: 'post',
    data
  })
}
//  修改集合绑定的小程序版本
export function editAppCollectionBindVersion(data) {
  return request({
    url: `/developer/appCollection/app`,
    method: 'put',
    data
  })
}
//  删除集合绑定的小程序
export function delAppCollectionBindApp(query) {
  return request({
    url: `/developer/appCollection/app`,
    method: 'delete',
    params: query
  })
}
//   获取所有小程序，含有小程序是否被该集合绑定的标识
export function appCollectionAppList(query) {
  return request({
    url: `/developer/appCollection/apps`,
    method: 'get',
    params: query
  })
}
//   删除集合信息
export function delAppCollection(id) {
  return request({
    url: `/developer/appCollection/${id}`,
    method: 'delete'
  })
}
// 获取某个小程序的所有版本
export function getAppVersionAll(appId) {
  return request({
    url: `/developer/appstore/release/${appId}`,
    method: 'get'
  })
}

// 历史版本列表删除接口
export function delHistoryVersion(releaseId) {
  return request({
    url: `/developer/appstore/release/${releaseId}`,
    method: 'delete'
  })
}
// 分页获取服务号信息，支持根据服务号名称模糊查询
export function getServiceNumber(query) {
  return request({
    url: `/serviceNumber`,
    method: 'get',
    params: query
  })
}
// 新建一个服务号
export function addServiceNumber(data) {
  return request({
    url: `/serviceNumber`,
    method: 'post',
    data
  })
}
//   编辑服务号信息
export function editServiceNumber(data) {
  return request({
    url: `/serviceNumber`,
    method: 'put',
    data
  })
}
//   删除服务号
export function delServiceNumber(serviceId) {
  return request({
    url: `/serviceNumber/${serviceId}`,
    method: 'delete'
  })
}
export function getAppVersionList(query) {
  return request({
    url: `/developer/appstore/app/version`,
    method: 'get',
    params: query
  })
}
export function getEdgeRole() {
  return request({
    url: `/edge/role`,
    method: 'get'
  })
}
export function getBulkPackage(query) {
  return request({
    url: `/bulkPackage`,
    method: 'get',
    params: query
  })
}
export function addBulkPackage(query) {
  return request({
    url: `/bulkPackage`,
    method: 'post',
    params: query
  })
}
export function editBulkPackage(query) {
  return request({
    url: `/bulkPackage`,
    method: 'put',
    params: query
  })
}
export function delBulkPackage(query) {
  return request({
    url: `/bulkPackage`,
    method: 'delete',
    params: query
  })
}
export function copyBulkPackage(query) {
  return request({
    url: `/bulkPackage/cp`,
    method: 'post',
    params: query
  })
}
// 批量包绑定一个小程序的某个版本
export function bulkPackageBindApp(query) {
  return request({
    url: `/bulkPackage/app`,
    method: 'post',
    params: query
  })
}
// 批量包修改绑定的小程序版本
export function bulkPackageBindVersion(query) {
  return request({
    url: `/bulkPackage/app`,
    method: 'put',
    params: query
  })
}
// 批量包解除与某个小程序的绑定关系
export function bulkPackageUnbindingApp(query) {
  return request({
    url: `/bulkPackage/app`,
    method: 'delete',
    params: query
  })
}
// 分页获取一个批量包绑定的小程序，支持根据小程序名称模糊搜索
export function getBulkPackageBindApp(query) {
  return request({
    url: `/bulkPackage/apps`,
    method: 'get',
    params: query
  })
}
// 批量包绑定一个集合
export function bulkPackageBindCollection(data) {
  return request({
    url: `/bulkPackage/collection`,
    method: 'post',
    data
  })
}
// 批量包与一个集合解除绑定关系
export function bulkPackageUnbindingCollection(query) {
  return request({
    url: `/bulkPackage/collection`,
    method: 'delete',
    params: query
  })
}
// 分页获取一个批量包绑定的集合
export function getBulkPackageBindCollection(query) {
  return request({
    url: `/bulkPackage/collections`,
    method: 'get',
    params: query
  })
}
export function getAllApp(query) {
  return request({
    url: `/bulkPackage/all/apps`,
    method: 'get',
    params: query
  })
}
export function getAllCollection(query) {
  return request({
    url: `/bulkPackage/all/collection`,
    method: 'get',
    params: query
  })
}
export function getBulkPackageAll(query) {
  return request({
    url: `/bulkPackage/all`,
    method: 'get',
    params: query
  })
}
// 批量修改标签/类型
export function labelBatchUpdate(data) {
  return request({
    url: `/developer/appstore/label`,
    method: 'put',
    data
  })
}
export function typeBatchUpdate(data) {
  return request({
    url: `/developer/appstore/category`,
    method: 'put',
    data
  })
}
// 根据id获取一个开发者组织的信息
export function getDeveloperOrgById(id) {
  return request({
    url: `/developerOrganization/detail/${id}`,
    method: 'get'
  })
}
